import React from 'react';
import singlebg from '../../assets/images/single-c-bg.png';
import { StaticQuery, graphql } from "gatsby"

const WorkflowBanner = () => (
    <StaticQuery
         query={graphql`
            query {
                allWpPage(filter: {slug: {eq: "work-flow"}}) {
                    edges {
                      node {
                        slug
                        TeamlanceWorkflow {
                          header {
                            title
                            description
                          }
                          workSteps {
                            steps {
                              description
                              readMoreLink
                              readMoreText
                              title
                              subTitle
                            }
                          }
                          workFeatures {
                            features {
                              title
                              iconSvg
                              description
                            }
                          }
                        }
                      }
                    }
                  }
            }
         `}
         render={data => {
             return(
                data && data.allWpPage &&
                data.allWpPage.edges &&
                data.allWpPage.edges[0] &&
                data.allWpPage.edges[0].node &&
                data.allWpPage.edges[0].node.TeamlanceWorkflow &&
                <section className="workflow-banner">
                    <div className="bn-bg quote-bg">
                        <img src={singlebg} alt="case study" />
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12  d-flex flex-column sectiontop-pd ">
                                <div className="quote-banner workflow text-center case-heading my-auto ml-0 ">
                                    <h3 className="">{data.allWpPage.edges[0].node.TeamlanceWorkflow.header.title?data.allWpPage.edges[0].node.TeamlanceWorkflow.header.title: "Our Workflow" }</h3>
                                    {data.allWpPage.edges[0].node.TeamlanceWorkflow.header.description?
                                    <p>
                                       {data.allWpPage.edges[0].node.TeamlanceWorkflow.header.description}
                                    </p>:
                                    <p>
                                        We have completely reimagined the development process to give you a service <br/> you can trust every time
                                    </p>}
                                </div>
                            </div>
                        </div> 
                    </div>
                 </section>
             )
         }}
    />
    
)

export default WorkflowBanner;